import React, { useEffect, useState, useCallback } from 'react';
import './TutorialSystem.css';

const TutorialOverlay = ({ targetElement, config }) => {
    const [rect, setRect] = useState(null);

    const calculateRect = useCallback(() => {
        if (targetElement) {
            const domRect = targetElement.getBoundingClientRect();
            const padding = 6;
            setRect({
                x:      domRect.left   - padding,
                y:      domRect.top    - padding,
                width:  domRect.width  + padding * 2,
                height: domRect.height + padding * 2,
                rx:     8, // rounded cutout
            });
        }
    }, [targetElement]);

    useEffect(() => {
        calculateRect();
        window.addEventListener('resize', calculateRect);
        window.addEventListener('scroll', calculateRect, true);
        return () => {
            window.removeEventListener('resize', calculateRect);
            window.removeEventListener('scroll', calculateRect, true);
        };
    }, [calculateRect]);

    if (!rect) return null;

    const overlayColor = config?.overlayColor || 'rgba(0, 0, 0, 0.65)';
    const cx = rect.x + rect.width  / 2;
    const cy = rect.y + rect.height / 2;
    // Use half-diagonal as the base beacon radius so it always clears the corners
    const baseR = Math.sqrt((rect.width / 2) ** 2 + (rect.height / 2) ** 2) + 2;

    return (
        <div
            className="tutorial-overlay"
            style={{
                position:      'fixed',
                top:           0,
                left:          0,
                width:         '100vw',
                height:        '100vh',
                zIndex:        9998,
                pointerEvents: 'none',
            }}
        >
            <svg width="100%" height="100%" style={{ display: 'block' }}>
                <defs>
                    <mask id="tutorial-cutout-mask">
                        {/* Opaque backdrop */}
                        <rect width="100%" height="100%" fill="white" />
                        {/* Transparent cutout over the target */}
                        <rect
                            x={rect.x}
                            y={rect.y}
                            width={rect.width}
                            height={rect.height}
                            rx={rect.rx}
                            ry={rect.rx}
                            fill="black"
                        />
                    </mask>
                </defs>

                {/* Dark backdrop with cutout */}
                <rect
                    width="100%"
                    height="100%"
                    fill={overlayColor}
                    mask="url(#tutorial-cutout-mask)"
                />

                {/* Glow ring — static, slowly pulses */}
                <rect
                    className="tutorial-glow-ring"
                    x={rect.x - 4}
                    y={rect.y - 4}
                    width={rect.width  + 8}
                    height={rect.height + 8}
                    rx={rect.rx + 4}
                    ry={rect.rx + 4}
                    fill="none"
                    stroke="rgba(255, 105, 0, 0.75)"
                    strokeWidth="2"
                />

                {/* Beacon pulse — expands outward and fades */}
                <circle
                    className="tutorial-beacon-ring"
                    cx={cx}
                    cy={cy}
                    r={baseR}
                    fill="none"
                    stroke="rgba(255, 105, 0, 0.6)"
                    strokeWidth="3"
                />
            </svg>
        </div>
    );
};

export default TutorialOverlay;
